"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Tools = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Tools"));

// Generated by script, don't edit it please.
var Tools = (0, _createSvgIcon["default"])({
  as: _Tools["default"],
  ariaLabel: 'tools',
  category: 'action',
  displayName: 'Tools'
});
var _default = Tools;
exports["default"] = _default;
module.exports = exports.default;